import * as React from "react";
import { Box, Typography } from "@mui/material";
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartTooltip
} from "@progress/kendo-react-charts";
import "hammerjs";

const StackedBarChart = ({ color, data, legendText, count }) => {
  const sx = {
    container: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      paddingY: "20px",
      gap: "5px",
      span: {
        color: "darkBlue.c100"
      }
    }
  };

  const [firstSeries, secondSeries, thirdSeries] = [
    data.map((val) => val.scoreDecreasedRate),
    data.map((val) => val.scoreIncreasedRate),
    data.map((val) => val.scoreRetainedRate)
  ];

  return (
    <Box>
      <Box sx={sx.container}>
        <Box sx={{ background: (theme) => theme.palette.acqua.c110, height: "12px", width: "12px" }}></Box>
        <Typography variant="overline1">SCORE INCREASED</Typography>
        <Box sx={{ background: (theme) => theme.palette.darkBlue.c10, height: "12px", width: "12px" }}></Box>
        <Typography variant="overline1">NO CHANGE</Typography>
        <Box sx={{ background: (theme) => theme.palette.negative.c100, height: "12px", width: "12px" }}></Box>
        <Typography variant="overline1">SORE DECREASED</Typography>
      </Box>

      <Chart transitions={false}>
        <ChartValueAxis>
          <ChartValueAxisItem majorGridLines={true} color="#9292AF" font="Poppins" />
        </ChartValueAxis>
        <ChartCategoryAxis>
          <ChartCategoryAxisItem
            majorGridLines={true}
            categories={data.map((val) => val.month)}
            color="#9292AF"
            font="Poppins"
          />
        </ChartCategoryAxis>
        <ChartTooltip background={color} format="{0:n}%" />
        <ChartSeries>
          <ChartSeriesItem
            type="column"
            stack={{
              type: "100%"
            }}
            color="#D14343"
            data={firstSeries}
            gap={5}
          />
          <ChartSeriesItem gap={5} type="column" color="#E9E9EF" data={thirdSeries} />
          <ChartSeriesItem gap={5} type="column" color="#00CBA9" data={secondSeries} />
        </ChartSeries>
      </Chart>
    </Box>
  );
};

export default StackedBarChart;
